import Seo from "./Seo";
import Reveal from "./Reveal";

export default function LegalPage({ testid, eyebrow = "Legal", title, updated, intro, sections = [], seoTitle, seoDescription }) {
  return (
    <main data-testid={testid} className="bg-charcoal pt-28 sm:pt-32">
      <Seo
        title={seoTitle || title}
        description={seoDescription}
        path={`/${testid.replace("-page", "")}`}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: title, path: `/${testid.replace("-page", "")}` },
        ]}
      />
      <section className="mx-auto max-w-3xl px-6 pb-28 sm:px-12">
        <Reveal>
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-brass">{eyebrow}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-6 font-serif text-4xl font-light leading-tight tracking-tight text-ivory sm:text-5xl">{title}</h1>
        </Reveal>
        {updated && (
          <Reveal delay={0.15}>
            <p className="mt-4 text-[11px] tracking-[0.25em] text-ivory/40">LAST UPDATED · {updated}</p>
          </Reveal>
        )}
        {intro && (
          <Reveal delay={0.2}>
            <p className="mt-8 text-base font-light leading-relaxed text-ivory/75">{intro}</p>
          </Reveal>
        )}

        <div className="mt-12 space-y-10">
          {sections.map((s, i) => (
            <Reveal key={i} delay={Math.min(0.05 * i, 0.3)}>
              <div data-testid={`${testid}-section-${i}`}>
                <h2 className="font-serif text-xl font-light text-ivory sm:text-2xl">{s.heading}</h2>
                {s.body && <p className="mt-3 text-sm leading-relaxed text-ivory/65 sm:text-base">{s.body}</p>}
                {s.items && (
                  <ul className="mt-4 space-y-2.5">
                    {s.items.map((it, idx) => (
                      <li key={idx} className="flex gap-3 text-sm leading-relaxed text-ivory/65 sm:text-base">
                        <span className="mt-1 flex-shrink-0 text-brass/60">—</span>
                        <span>{it}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
